// @ts-nocheck
import { divider, secondary, action } from 'assets/colors/colors';

export function createMaterialReactTableTheme() {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          minHeight: 'calc(100vh - 198px)!important',
          maxHeight: 'calc(100vh - 198px)!important',
          borderRadius: '8px',

          '& .MuiTableBody-root': {
            minHeight: 'calc(100vh - 247px)!important',
          },
          '&::-webkit-scrollbar': {
            width: '12px',
            height: '12px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f5f5f5',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#bdbdbd',
            borderRadius: '4px',
          },

          '& .MuiTableRow-root': {
            '& .action-column-cell': {
              paddingTop: '0',
              paddingBottom: '0',
            },
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          '& .MuiTablePagination-menuItem': {
            fontSize: '12px',
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          fontSize: '0.7rem',
          border: '1px solid #EEEEEE',
          borderBottom: '0',
          borderRight: '0',
          borderRadius: '8px',

          '& .MuiCheckbox-root': {
            padding: '14px',
          },

          '& .MuiTableCell-root:first-child': {
            paddingLeft: '20px',
          },

          '& th::before': {
            background: '#D3D7DD!important',
          },

          '& td': { background: '#fff' },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '6px 8px',
          backgroundColor: 'none',
          boxShadow: 'none',

          '&::before': {
            // boxShadow: 'none!important' was here, but it was causing the table to not show the divider between other columns and action column,
            background: '#fff !important',
          },

          '& .MuiInput-root': {
            '&::before': {
              borderBottom: 'none',
            },
            '&:hover::before': {
              borderBottom: 'none!important',
            },
            '&::after': {
              border: ' none!important',
            },
          },

          '& .MuiInput-input': {
            border: '1px solid',
            borderColor: divider,
            borderRadius: 4,

            '&:hover': {
              borderColor: secondary.main,
            },

            '&:focus': {
              borderColor: secondary.main,
            },
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& th': {
            backgroundColor: '#D3D7DD',
            color: secondary.contrastText,
            textWrap: 'nowrap',
            fontWeight: '500',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          boxShadow: 'none!important',

          '&:hover td:after': {
            backgroundColor: `${action.hover}!important`,
          },

          '&.Mui-selected td:after': {
            backgroundColor: `${action.selected}!important`,
          },

          '&.Mui-selected:hover td:after': {
            backgroundColor: `${action.selectedHover}!important`,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.MuiCheckbox-indeterminate .MuiSvgIcon-root': {
            color: secondary.main,
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          '& .MuiPaper-root.MuiPopover-paper': {
            boxShadow: '0px 4px 16px 0px #00000029',
            padding: '5px 0',
          },
        },
      },
    },
  };
}
